// extracted by mini-css-extract-plugin
export var root = "PlasmicHomepage-module--root--IIg7c";
export var header = "PlasmicHomepage-module--header--GKrN4";
export var freeBox__qSoMw = "PlasmicHomepage-module--freeBox__qSoMw--HqqYJ";
export var info = "PlasmicHomepage-module--info--YueZE";
export var infoicon = "PlasmicHomepage-module--infoicon--u+8pr";
export var modeToggle = "PlasmicHomepage-module--modeToggle--KJqjr";
export var darkmodeIcon = "PlasmicHomepage-module--darkmodeIcon--YSBia";
export var logo = "PlasmicHomepage-module--logo--nbnWF";
export var freeBox__sPasa = "PlasmicHomepage-module--freeBox__sPasa--2zklo";
export var text___70UnO = "PlasmicHomepage-module--text___70UnO--cX7Bs";
export var text__bbuH = "PlasmicHomepage-module--text__bbuH--5IV80";
export var text__evUhE = "PlasmicHomepage-module--text__evUhE--+q3uU";
export var footer = "PlasmicHomepage-module--footer--yFT7c";
export var button__g6Wpw = "PlasmicHomepage-module--button__g6Wpw--kjkpV";
export var svg___7F69M = "PlasmicHomepage-module--svg___7F69M--nEjN0";
export var svg__c6Nly = "PlasmicHomepage-module--svg__c6Nly--EAkLe";
export var button__waSwW = "PlasmicHomepage-module--button__waSwW--j0yvW";
export var svg__jmqts = "PlasmicHomepage-module--svg__jmqts--cfAr9";
export var text__sxMwY = "PlasmicHomepage-module--text__sxMwY--hyv52";
export var svg__vHKew = "PlasmicHomepage-module--svg__vHKew--UyF2g";
export var infoModal = "PlasmicHomepage-module--infoModal--GUaQD";
export var h1 = "PlasmicHomepage-module--h1--QWtNn";
export var freeBox__gQtHi = "PlasmicHomepage-module--freeBox__gQtHi--ZiVx2";
export var h2 = "PlasmicHomepage-module--h2--8hmgj";